import React, {useMemo} from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const STATUS_COLORS = {
  completed: '#1FA971',
  pending: '#E6B800',
  failed: '#B3262E',
  canceled: '#F59E0B',
  refunded: '#6EC6E8',
  expired: '#D6D9DD',
  on_hold: '#7A6FF0',
  blocked: '#3A3F44',
};

export default function PaymentLastMonthChart({data = [], title = 'Payment last month'}) {
  const chartData = useMemo(() => {
    const labels = data.map(d => d.date);
    const statuses = Object.keys(STATUS_COLORS);

    const datasets = statuses.map(status => ({
      label: status.replace('_', ' '),
      data: data.map(d => d.buckets?.[status] || 0),
      backgroundColor: STATUS_COLORS[status],
      stack: 'stack0',
      borderRadius: 4,
      borderSkipped: false,
      barPercentage: 0.8,
      categoryPercentage: 0.9,
    }));

    return {
      labels,
      datasets,
    };
  }, [data]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          boxWidth: 8,
          padding: 20,
          font: {
            size: 11,
            family: "'Inter', sans-serif",
            weight: '500'
          }
        }
      },
      title: {
        display: false,
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
        ticks: {
          color: '#6B7280',
          font: {
            size: 10,
            family: "'Inter', sans-serif"
          }
        }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.04)',
          drawBorder: false,
        },
        ticks: {
          color: '#6B7280',
          font: {
            size: 10,
            family: "'Inter', sans-serif"
          }
        }
      },
    },
  };

  return (
    <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 p-6">
      <h3 className="text-base font-bold text-gray-900 mb-4">{title}</h3>
      <div className="h-64">
        {!data?.length ? (
          <div className="h-full flex items-center justify-center text-sm text-gray-500">No data</div>
        ) : (
          <Bar options={options} data={chartData} />
        )}
      </div>
    </div>
  );
}
